var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationLaboratorySchool2SvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#333062",
    stroke: "#333062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d0d7df;}.cls-2{fill:#49aaee;}.cls-3{fill:#d04159;}.cls-4{fill:#768ba0;}.cls-5{fill:#4c6681;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    id: "Science"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.056,29.108a12,12,0,0,0,23.418,2.409C30.118,31.786,22.8,25.607,15.056,29.108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,16A12,12,0,0,0,15,28c0,.374.022.743.056,1.108,7.745-3.5,15.062,2.678,23.418,2.409A12,12,0,0,0,27,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.021,28.416a9.986,9.986,0,0,0,19.352,3.042C29.572,30.869,23.4,26.78,17.021,28.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.513,31.358s.01.01,0,.01l-.2-.03A1.355,1.355,0,0,0,35.513,31.358Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 8,
    width: 6,
    x: 24,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 3,
    rx: 1,
    ry: 1,
    width: 10,
    x: 22,
    y: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5,0H6A1,1,0,0,1,7,1V44a0,0,0,0,1,0,0H4a0,0,0,0,1,0,0V1A1,1,0,0,1,5,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 3,
    rx: 1,
    ry: 1,
    width: 30,
    x: 2,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4,
    rx: 1,
    ry: 1,
    width: 42,
    y: 44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationLaboratorySchool2SvgrepoCom);
export default __webpack_public_path__ + "static/media/education-laboratory-school-2-svgrepo-com.6bad6db691bab3f202ce19473fd4ea44.svg";
export { ForwardRef as ReactComponent };